export const REQUEST_CACHE_REFRESH = "REQUEST_CACHE_REFRESH";
export const RECEIVE_CACHE_REFRESH = "RECEIVE_CACHE_REFRESH";
export const ERROR = "ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
